import { Component } from '@angular/core';
import { Meta ,Title} from '@angular/platform-browser';

@Component({
    selector: 'app-how-it-works',
    templateUrl: './how-it-works.component.html',
    styleUrls: ['./how-it-works.component.css'],
    standalone: false
})
export class HowItWorksComponent {
  constructor(private meta: Meta, private title: Title) {
    this.title.setTitle('How It Works |Family Central');
    this.meta.addTag({
      name: 'description',
      content:
        'See what tools Family Central provides, and how everything works together to help your family.',
    });
  }
}
